import React from 'react';
import { Logo } from '../Logo';
import { ThemeToggle } from '../ThemeToggle';
import { profile } from '../../data/profile';
export function MobileHeader() {
  return <header className="sticky top-0 z-40 border-b border-line bg-canvas/90 backdrop-blur lg:hidden" data-id="element-292" data-mp="3m74kb2e6zv68">
      <div className="flex items-center justify-between px-5 py-3 md:px-8" data-id="element-293" data-mp="3r67rasdqgbgu">
        <a href="#top" className="flex items-center gap-2.5" data-id="element-294" data-mp="3r8ae73jl9ohc">
          <Logo className="h-8 w-8" data-id="element-295" data-mp="irfnsnjz9wk5" />
          <span className="text-sm font-semibold text-fg" data-id="element-296" data-mp="ish8ljqspxf2">{profile.name}</span>
        </a>
        <div className="flex items-center gap-2" data-id="element-297" data-mp="nopioiq4z0fd">
          <ThemeToggle data-id="element-298" data-mp="914j2ysgzjc7" />
          <a href={`mailto:${profile.email}`} className="rounded-full bg-ink px-4 py-2 text-xs font-medium text-white transition-transform duration-150 ease-out active:scale-[0.97]" data-id="element-299" data-mp="8ztdctfgs1ig">
            Let's talk
          </a>
        </div>
      </div>
    </header>;
}